"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _find = _interopRequireDefault(require("lodash/find"));

var _ConfigShippingView = _interopRequireDefault(require("./ConfigShippingView"));

var ConfigShippingContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ConfigShippingContainer, _Component);

  function ConfigShippingContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ConfigShippingContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ConfigShippingContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      selectedDeliveryLocation: null,
      shippingTime: 0,
      postalCode: ''
    };

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          shippingConfig = _this$props.shippingConfig,
          deliveryLocations = _this$props.deliveryLocations;
      if (!shippingConfig) return;
      var selectedDeliverylocation = (0, _find.default)(deliveryLocations, function (option) {
        return option.value === shippingConfig.destinationCountryCode;
      });

      _this.setState({
        selectedDeliveryLocation: selectedDeliverylocation,
        shippingTime: shippingConfig.shippingTime,
        postalCode: shippingConfig.destinationPostalCode
      });
    };

    _this.ondeliveryLocationChange = function (selectedSingle) {
      _this.setState({
        selectedDeliveryLocation: selectedSingle
      });
    };

    _this.onPostalCodeInputChange = function (event) {
      _this.setState({
        postalCode: event.target.value
      });
    };

    _this.onShippingTimeInputChange = function (e) {
      _this.setState({
        shippingTime: parseInt(e.target.value, 10)
      });
    };

    _this.onSubmit = function () {
      var _this$state = _this.state,
          selectedDeliveryLocation = _this$state.selectedDeliveryLocation,
          shippingTime = _this$state.shippingTime,
          postalCode = _this$state.postalCode;

      _this.props.onShippingSubmit(selectedDeliveryLocation ? selectedDeliveryLocation.value : null, postalCode, !shippingTime || shippingTime === 0 ? null : shippingTime);
    };

    _this.onResetAll = function () {
      _this.setState({
        selectedDeliveryLocation: null,
        shippingTime: 0,
        postalCode: ''
      }, _this.onSubmit);
    };

    return _this;
  }

  (0, _createClass2.default)(ConfigShippingContainer, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          selectedDeliveryLocation = _this$state2.selectedDeliveryLocation,
          shippingTime = _this$state2.shippingTime,
          postalCode = _this$state2.postalCode;
      var _this$props2 = this.props,
          deliveryLocations = _this$props2.deliveryLocations,
          closeModal = _this$props2.closeModal,
          open = _this$props2.open;
      return _react.default.createElement(_ConfigShippingView.default, {
        deliveryLocations: deliveryLocations,
        ondeliveryLocationChange: this.ondeliveryLocationChange,
        selectedDeliveryLocation: selectedDeliveryLocation,
        shippingTime: shippingTime,
        onShippingTimeInputChange: this.onShippingTimeInputChange,
        postalCode: postalCode,
        onPostalCodeInputChange: this.onPostalCodeInputChange,
        onSubmit: this.onSubmit,
        onResetAll: this.onResetAll,
        closeModal: closeModal,
        open: open
      });
    }
  }]);
  return ConfigShippingContainer;
}(_react.Component);

exports.default = ConfigShippingContainer;